export const ACTION_STATE = {
  LOGIN: 'login',
  STREAM: 'stream',
  PURCHASE: 'purchase',
  NONE: 'none',
}

export const ACTION_DISPLAY = {
  COMING_SOON: '공개 예정',
  PURCHASE: '이용권 구매하기',
  MEMO: '판매 종료',
  DISABLE: '',
}

export const CONTENT_STATUS = {
  COMING_SOON: 'commingsoon',
  CONTINUE: 'continue',
  NORMAL: 'normal',
  LATEST: 'latest',
  BEGIN: 'begin',
}
